module.exports = __webpack_public_path__ + "static/img/sub04_2.c9bde38.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/sub04_2.png
// module id = r1a4
// module chunks = 1